import { isUndefined } from 'lodash-es';

export interface AppPageHeaderProps {
  title: string;
  titleDescription?: string;
  extra?: React.ReactNode;
  header?: React.ReactNode;
}

export const AppPageHeader = (props: AppPageHeaderProps) => {
  const { title, titleDescription, extra, header } = props;

  return (
    <>
      {isUndefined(header) ? (
        <header className="px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h4 className="text-base font-medium mb-0">{title}</h4>
            <span className="text-xs text-content-200 pt-1">{titleDescription}</span>
          </div>
          {extra}
        </header>
      ) : (
        header
      )}
      <div className="h-[1px] w-full bg-fill-300" />
    </>
  );
};
